import { render } from "./QuotePhil.vue?vue&type=template&id=86a3fba2&scoped=true"
import script from "./QuotePhil.vue?vue&type=script&lang=js"
export * from "./QuotePhil.vue?vue&type=script&lang=js"

import "./QuotePhil.vue?vue&type=style&index=0&id=86a3fba2&scoped=true&lang=css"

import exportComponent from "C:\\code\\kascenskaforvt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-86a3fba2"]])

export default __exports__